import type { Pet } from "../data/pets";

export const SITE_ORIGIN = "https://codexpetlab.com";

export function petCliCommand(pet: Pet): string {
  return `npx codexpetlab add ${pet.id}`;
}

export function petCurlCommand(pet: Pet): string {
  return [
    `curl -L "${SITE_ORIGIN}/api/pets/${pet.id}/download" \\`,
    `  -o "/tmp/${pet.id}.codex-pet.zip" &&`,
    `mkdir -p "$HOME/.codex/pets/${pet.id}" &&`,
    `unzip -o "/tmp/${pet.id}.codex-pet.zip" \\`,
    `  -d "$HOME/.codex/pets/${pet.id}"`,
  ].join("\n");
}

export function petCodexInstallUrl(pet: Pet): string {
  return `codex://new?prompt=${encodeURIComponent(`Install this pet: ${petCliCommand(pet)}`)}`;
}
